module.exports = __webpack_public_path__ + "static/media/heroBack1.d2f8a39d.svg";